/** Two-line label for session start buttons: BEGIN with a smaller SESSION beneath. */
export const BeginSessionLabel = () => (
  <span className="flex flex-col items-center leading-none" data-testid="begin-session-label">
    <span className="text-[15px] tracking-[0.05em]">Begin</span>
    <span className="text-[10px] tracking-[0.14em] opacity-70 mt-[3px]">Session</span>
  </span>
);
